import React, { useState } from 'react';
import { Mail, Send, CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

const Contact = () => {
  const [copied, setCopied] = useState(false);

  const email = 'praneethartha381@gmail.com';

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(email);
    setCopied(true);
    toast.success('Email copied to clipboard!');
    setTimeout(() => setCopied(false), 3000);
  };

  const handleSendEmail = () => {
    window.location.href = `mailto:${email}?subject=Inquiry from NoTrackTools Website`;
  };

  return (
    <div className="py-20 animate-fade-in">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h1 className="text-4xl lg:text-5xl font-bold mb-6">
            Get in <span className="gradient-text">Touch</span>
          </h1>
          <p className="text-muted-foreground text-lg leading-relaxed">
            Have questions, feedback, or business inquiries? We are here to help!
          </p>
        </div>

        {/* Contact Card */}
        <div className="max-w-2xl mx-auto">
          <div className="glass-card p-8 lg:p-12 text-center">
            {/* Email Icon */}
            <div className="inline-flex p-6 glass rounded-2xl mb-6 animate-glow-pulse">
              <Mail className="w-12 h-12 text-primary" />
            </div>

            <h2 className="text-2xl font-bold mb-4">Contact Us Directly</h2>
            
            <p className="text-muted-foreground mb-8 leading-relaxed">
              Reach out to us via email. We typically respond within 24-48 hours.
            </p>

            {/* Email Display */}
            <div className="glass p-4 rounded-lg mb-6">
              <p className="text-sm text-muted-foreground mb-2">Email Address</p>
              <p className="text-xl font-semibold text-foreground select-all">
                {email}
              </p>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                size="lg"
                onClick={handleSendEmail}
                className="hover:glow-primary"
              >
                <Send className="mr-2 w-4 h-4" />
                Send Email
              </Button>
              <Button
                size="lg"
                variant="outline"
                onClick={handleCopyEmail}
                className="glass"
              >
                {copied ? (
                  <>
                    <CheckCircle className="mr-2 w-4 h-4 text-success" />
                    Copied!
                  </>
                ) : (
                  <>
                    <Mail className="mr-2 w-4 h-4" />
                    Copy Email
                  </>
                )}
              </Button>
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="glass-card p-6 text-center">
              <h3 className="font-semibold mb-2">Response Time</h3>
              <p className="text-muted-foreground text-sm">
                We aim to respond within 24-48 hours during business days.
              </p>
            </div>
            <div className="glass-card p-6 text-center">
              <h3 className="font-semibold mb-2">Business Hours</h3>
              <p className="text-muted-foreground text-sm">
                Monday - Friday, 9:00 AM - 6:00 PM (EST)
              </p>
            </div>
          </div>

          {/* Privacy Note */}
          <div className="mt-8 glass p-6 rounded-lg border border-primary/20">
            <p className="text-sm text-muted-foreground text-center">
              <span className="font-semibold text-foreground">Privacy Note:</span> We only use
              your email to respond to your inquiry. We never share, sell, or use your contact
              information for marketing purposes.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
